// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1_Zlz","cls2":"PaperPreviewList-cls2_LRC PaperPreviewList-cls1_Zlz"};